import React from 'react';
import DashboardTable from '../DashboardTable/dashboard-table';

interface SuppliersDashboardProps {
    accessRole: string; // or use the correct type for UserRole if available
}

const SuppliersDashboard: React.FC<SuppliersDashboardProps> = ({ accessRole }) => {
    return (
        <div>
            <DashboardTable accessRole={accessRole} />
        </div>

    );
};

export default SuppliersDashboard;
